module.exports = __webpack_public_path__ + "static/media/espana.36938bbe.svg";